import { createTheme } from '@mui/material';

export const GREEN = '#B7D423';
export const TERTIARY_GREY = '#21241E';

export const theme = createTheme({
  palette: {
    primary: {
      main: GREEN
    },
    secondary: {
      main: TERTIARY_GREY
    }
  },
  typography: {
    fontFamily: ['Gilroy-Medium', 'sans-serif'].join(',')
  }
});

export const SALT_PAN = '#ECF0E5';
export const SUVA_GREY = '#8E8E8E';
export const BLACK = '#000';
export const WHITE = '#fff';
export const OCEAN_BLUE = '#D9D9D9';
